import {useMenuTriggerState as $e17gp$useMenuTriggerState} from "@react-stately/menu";
import {useSingleSelectListState as $e17gp$useSingleSelectListState} from "@react-stately/list";
import {useState as $e17gp$useState} from "react";




function $2bc3a590c5373a4e$export$5159ec8b34d4ec12(props) {
    let triggerState = $e17gp$useMenuTriggerState(props);
    let listState = $e17gp$useSingleSelectListState({
        ...props,
        onSelectionChange: (key)=>{
            if (props.onSelectionChange != null) props.onSelectionChange(key);
            triggerState.close();
        }
    });
    let [isFocused, setFocused] = $e17gp$useState(false);
    return {
        ...listState,
        ...triggerState,
        open () {
            // Don't open if the collection is empty.
            if (listState.collection.size !== 0) triggerState.open();
        },
        toggle (focusStrategy) {
            if (listState.collection.size !== 0) triggerState.toggle(focusStrategy);
        },
        isFocused: isFocused,
        setFocused: setFocused
    };
}




export {$2bc3a590c5373a4e$export$5159ec8b34d4ec12 as useSelectState};
//# sourceMappingURL=module.js.map
